const VARIANT_REPLACEMENTS = [
  [/^js$/i, 'javascript'],
  [/^cpp$/i, 'c++'],
  [/^cxx$/i, 'c++'],
  [/^csharp$/i, 'c#'],

  [/^l10n/i, 'localization'],
  [/^i18n$/i, 'internationalization'],

  [/colou/gi, 'colo'], // colour => color
  [/localis/gi, 'localiz'], // localisation => localization
  [/internationalis/gi, 'internationaliz'], // internationalisation => internationalization
]

let SPLIT_TOKEN_REGEX
try {
  SPLIT_TOKEN_REGEX = new RegExp('[^\\p{L}\\p{N}#+]+', 'u')
} catch {
  // Fallback to ASCII-only splitting when Unicode property escapes are unavailable.
  SPLIT_TOKEN_REGEX = /[^a-z0-9#+]+/i
}

export function customTokenizer(str) {
  return rawTokens(str).flatMap(indexTokens).map(normalizeToken)
}

export function customSearchTokenizer(str) {
  return rawTokens(str).map(normalizeToken)
}

export function createMinisearch(MiniSearch, data) {
  const instance = createMinisearchInstance(MiniSearch)
  instance.addAll(data)
  return instance
}

function createMinisearchInstance(MiniSearch) {
  return new MiniSearch({
    idField: 'name',
    fields: ['name', 'description', 'author', 'platforms', 'labels'],
    tokenize: customTokenizer,
    storeFields: [
      'name',
      'description',
      'author',
      'stars',
      'installs_total',
      'installs_recent',
      'installs_recent_period',
      'first_seen',
      'last_modified',
      'archived_at',
      'removed',
      'platforms',
      'platform_statement',
      'labels',
      'magic_score',
      'magic',
      'outdated',
      'graveyard',
      'graveyard_id',
      'graveyard_only',
    ],
    searchOptions: {
      boost: { author: 2, name: 2 },
      prefix: true,
      tokenize: customSearchTokenizer,
    },
  })
}

function rawTokens(str) {
  return str.split(SPLIT_TOKEN_REGEX).filter(Boolean)
}

function indexTokens(token) {
  const parts = splitCamelCase(token)
  const suffixes = parts.slice(0, -1).map((_, index) => parts.slice(index).join(''))
  return parts.concat(token, suffixes)
}

function splitCamelCase(token) {
  return token
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .replace(/([A-Z]+)([A-Z][a-z])/g, '$1 $2')
    .split(SPLIT_TOKEN_REGEX)
}

function normalizeToken(token) {
  for (const [pattern, replacement] of VARIANT_REPLACEMENTS) {
    token = token.replace(pattern, replacement)
  }
  return token
}
